module.exports = __webpack_public_path__ + "img/visa-square.2ec996ab.svg";